import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook simplified - cache invalidation now handled in AuthContext
 * This hook only provides access to queryClient for manual operations
 */
export const useCacheInvalidation = () => {
  const queryClient = useQueryClient();

  return { queryClient };
};